var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"overviewTitle"},[_c('h2',{staticClass:"mb-6"},[_vm._v(_vm._s(_vm.$t("overview.productionUnit.title")))]),_c('div',{staticClass:"PU-list"},[_vm._l((_vm.activeFactoryProductionUnits),function(pu){return [_c('wx-skeleton-loader',{key:pu.id,attrs:{"type":"image"}})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }